import { render, staticRenderFns } from "./ResourcesMediaType.vue?vue&type=template&id=5c32aee2&scoped=true"
import script from "./ResourcesMediaType.vue?vue&type=script&lang=js"
export * from "./ResourcesMediaType.vue?vue&type=script&lang=js"
import style0 from "./ResourcesMediaType.vue?vue&type=style&index=0&id=5c32aee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32aee2",
  null
  
)

export default component.exports